import type { ResourcesConfig } from 'aws-amplify'

import { getAPIConfig } from '@/utils/apiConfig'

export const getAmplifyConfig = async (): Promise<ResourcesConfig> => {
  const apiConfig = await getAPIConfig()
  const url = new URL(apiConfig.userPool.userPoolDomain)
  const publicUrl = import.meta.env.VITE_PUBLIC_URL as string

  return {
    Auth: {
      Cognito: {
        userPoolId: apiConfig.userPool.userPoolId,
        userPoolClientId: apiConfig.userPool.userPoolClientId,
        loginWith: {
          email: true,
          oauth: {
            domain: url.hostname,
            scopes: ['email', 'openid', 'profile'],
            redirectSignIn: [`${publicUrl}/callback`],
            redirectSignOut: [`${publicUrl}/sign-out`],
            responseType: 'code',
          },
        },
        userAttributes: {
          email: { required: true },
        },
      },
    },
  }
}
